import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MediumFacade, MediumGroup, PurchaseFacade, RelatedCardFacade, SessionService, TravelCardType } from '@ridango/components';
import { AuthService, BaseComponent, RelatedCard } from '@ridango/core';
import { Observable } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';



@Component( {
    selector: 'rwidget-corp-card-selection',
    templateUrl: './corporate-card-selection.component.html',
    styleUrls: [ './corporate-card-selection.component.scss' ]
} )
export class CorpCardSelectionComponent extends BaseComponent implements OnInit, OnDestroy {

    allNormalized$ = this.relatedCardFacade.allNormalized$;
    travelCardsIds$ = this.relatedCardFacade.allIds$;
    allCards$ = this.relatedCardFacade.typeTravelcardCards$;
    selectedTravelCardsIds$ = this.relatedCardFacade.selectedCardsIds$;
    sortField$ = this.relatedCardFacade.sortField$;
    sortDirection$ = this.relatedCardFacade.sortDirection$;
    mediumGroups$: Observable<MediumGroup[]> = this.mediumFacade.availableMediumGroups$;

    allCardsIds = [];
    selectedCardsIds: number[] = [];

    allAllowedCards: RelatedCard[] = [];
    allRelatedCards: any;
    cardType: TravelCardType;

    @Output() corporateCardsSelected = new EventEmitter<void>()

    constructor(
        private authService: AuthService,
        private sessionService: SessionService,
        private relatedCardFacade: RelatedCardFacade,
        private mediumFacade: MediumFacade,
        private purchaseFacade: PurchaseFacade
    ) {
        super();
    }

    ngOnInit () {
        if (this.sessionService.getLoginStatus()) {
            this.relatedCardFacade.fetchAllRelatedCards();
        }

        this.allCards$.pipe(
            takeUntil(this.componentDestroyed$),
            filter((cards) => cards.length > 0)
        ).subscribe((cards) => {
            this.setAllowedCards(cards);
        });

        this.selectedTravelCardsIds$.pipe(
            takeUntil(this.componentDestroyed$),
            filter((ids) => ids.length > 0)
        ).subscribe((ids) => {
            this.selectedCardsIds = ids;
        });

        this.allNormalized$.pipe(takeUntil(this.componentDestroyed$)).subscribe((cards) => {
            this.allRelatedCards = cards;
        });

        this.sortByNumber();

    }

    ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    travelCardClicked ( tcId ) {
        this.relatedCardFacade.toggleSelectedRelatedCard( tcId );
    }

    toggleAllTravelCards () {
        this.relatedCardFacade.toggleAllRelatedCards();
    }

    proceedToTicketSelection() {
        this.purchaseFacade.prepareCorporatePayloads({
            cardIds: this.selectedCardsIds,
            cardTypes: this.selectedCardsIds.map(cardId => this.allRelatedCards[cardId].card_type ?? ''),
            channel: 'web_corp',
            company_id: this.authService.getLoggedInUserCompanyId()
        });
        this.corporateCardsSelected.emit();
    }

    sortByNumber () {
        this.relatedCardFacade.sortByNumber();
    }

    sortByName () {
        this.relatedCardFacade.sortByName();
    }

    setAllowedCards(cards) {
        this.mediumGroups$.pipe(takeUntil(this.componentDestroyed$)).subscribe((groups) => {
            this.allAllowedCards = [];

            const mediumCardTypes = groups.find(({ type }) => type === 'Travelcard');
            if (mediumCardTypes) {
                cards.forEach((card) => {
                    if (mediumCardTypes.travelcardTypes.includes(card.card_type)) {
                        this.allAllowedCards.push(card);
                    }
                });
            }
        });
    }
}
